// NEW: UI_REVAMP
import { Flex, Image, Text } from '@chakra-ui/react';
import { animated, useSpring } from '@react-spring/web';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { useLocation, useNavigate } from 'react-router-dom';

import PropTypes from 'prop-types';
import { getSrvTimeApi, getVersionApi } from '../../api/query/authApi';
import { useBettingScreen, useGameStore } from '../../hooks/useStore';
import ImgComp from '../../utils/ImgComp';
import MenuList from './MenuList';
import './drawer.css';

export const MobileSideBar = ({ setIsOpen, isOpen, isAgent = false, setDate, onClickLogout }) => {
	const navigate = useNavigate();
	const location = useLocation();
	const removeAll = useBettingScreen((s) => s.removeAll);
	const removeAllStl = useBettingScreen((s) => s.removeAllStl);
	const setSiteId = useGameStore((s) => s.setSiteId);
	const isThirdPartyLogin = sessionStorage.getItem('isThirdPartyLogin') === 'true';

	const { data: srvTime } = useQuery(['srvTime'], getSrvTimeApi);
	const { data: version } = useQuery(['version'], getVersionApi);

	const drawerAnimation = useSpring({
		transform: isOpen ? 'translateX(0%)' : 'translateX(-100%)',
	});

	const navigateWithReset = (path) => {
		setDate(dayjs(srvTime?.currTime).utc().tz('Asia/Kuala_Lumpur').toDate());
		removeAll();
		removeAllStl();
		setIsOpen(false);
		if (path) navigate(path);
	};

	const handleBetNavigation = (siteId, path) => {
		setSiteId(siteId);

		if (location.pathname === path) {
			siteId === 1 ? removeAll() : removeAllStl();
		} else {
			navigateWithReset(path);
		}
	};

	return (
		<animated.div
			className='mobile-sidebar-box'
			style={drawerAnimation}
			display={{ base: 'flex', lg: 'none' }}
		>
			<Flex flexDirection='column' h='100%' overflow='hidden'>
				<Flex justify='space-between' w='100%'>
					<Flex align='center' my={7}>
						<Flex direction='column' px={4}>
							<Image src='/assets/img/panalo-logo.png' w='90%' mb={2} />
							<Text color='white' fontSize='12px'>
								{version?.version} ver.
							</Text>
						</Flex>
					</Flex>

					<Flex align='flex-start' p={7} onClick={() => setIsOpen(false)}>
						<ImgComp svgName='close-icon' />
					</Flex>
				</Flex>

				<Flex flex='1' direction='column' overflowY='auto' overflowX='hidden' pb={6}>
					<MenuList
						isAgent={isAgent}
						isThirdPartyLogin={isThirdPartyLogin}
						handleBetNavigation={handleBetNavigation}
						navigateWithReset={navigateWithReset}
						onClickLogout={onClickLogout}
						isMobile={true}
					/>
				</Flex>

				<Text
					display='flex'
					alignItems='center'
					justifyContent='center'
					pt={6}
					pb='calc(24px + env(safe-area-inset-bottom, 0px))'
					color='white'
					fontSize='12px'
					textAlign='center'
					zIndex={1002}
					mt='auto'
				>
					© 2026 PANALO29 ALL RIGHT RESERVED.
				</Text>
			</Flex>
		</animated.div>
	);
};

MobileSideBar.propTypes = {
	setIsOpen: PropTypes.func,
	isOpen: PropTypes.bool,
	isAgent: PropTypes.bool,
	setDate: PropTypes.func,
	onClickLogout: PropTypes.func,
	onOpenResultPage: PropTypes.func,
	isOpenResultPage: PropTypes.bool,
	onCloseResultPage: PropTypes.func,
};
